import { t } from '@/i18n'

const companyTranslations: Record<string, string> = {
  Shop: 'close-delivery.company-shop',
  Bookings: 'close-delivery.company-bookings'
}

export function translateCompany(company: string) {
  return companyTranslations[company] ? t(companyTranslations[company]) : company
}
